// src/pages/UploadPage/StoreActions/aiGeneration.js
import { useState } from 'react';
import meshyService from '../../../Services/meshyService.js';

const useAIGeneration = () => {
  // AI generation states
  const [isGenerating, setIsGenerating] = useState(false);
  const [generationProgress, setGenerationProgress] = useState(0);
  const [generationStatus, setGenerationStatus] = useState('');

  // Generate 3D model from images using Meshy AI
  const generateModelFromImages = async (images, itemName, dimensions, user) => {
    try {
      console.log('🤖 AI MODE: Starting Meshy generation...');
      setIsGenerating(true);
      setGenerationProgress(0);
      setGenerationStatus('Starting AI generation...');

      // Generate 3D model using Meshy (with auto-download built in)
      const result = await meshyService.generateModelFromImages(
        images,
        itemName,
        dimensions,
        (progress, status) => {
          setGenerationProgress(progress);
          setGenerationStatus(status);
          console.log(`Progress: ${progress}% - ${status}`);
        },
        user  // This will auto-download to Firebase
      );

      console.log('✅ Meshy generation completed:', result);

      // Create the new item (URLs are already Firebase URLs from meshyService)
      const newItem = {
        id: Date.now().toString(),
        itemName,
        glbUrl: result.glbUrl,
        imageUrl: result.thumbnailUrl,
        timestamp: new Date().toISOString(),
        meshyTaskId: result.taskId,
        downloadedToFirebase: true, // Mark as already downloaded
      };

      setGenerationProgress(100);
      setGenerationStatus('Complete!');
      
      return newItem;
    } catch (error) {
      console.error('❌ Meshy generation failed:', error);
      throw new Error('AI generation failed: ' + error.message);
    } finally {
      setIsGenerating(false);
    }
  };

  // Reset generation state
  const resetGeneration = () => {
    setIsGenerating(false);
    setGenerationProgress(0);
    setGenerationStatus('');
  };

  return {
    // State
    isGenerating,
    generationProgress,
    generationStatus,
    
    // Actions
    generateModelFromImages,
    resetGeneration,
    
    // Direct setters (for compatibility)
    setIsGenerating,
    setGenerationProgress,
    setGenerationStatus,
  };
};

export default useAIGeneration;